import { render, staticRenderFns } from "./basicSet.vue?vue&type=template&id=49b66ef8&scoped=true&"
import script from "./basicSet.vue?vue&type=script&lang=js&"
export * from "./basicSet.vue?vue&type=script&lang=js&"
import style0 from "./basicSet.vue?vue&type=style&index=0&id=49b66ef8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b66ef8",
  null
  
)

export default component.exports